import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux';
import './MyPage.css'
import { setIsLoggedIn } from '../../store';

function MyPage () {
    const navigate = useNavigate();

    const dispatch = useDispatch();

    // 실제로는 유저 정보를 받아와서 표시하면 좋다.
    // 예: API 요청 등을 통해 받아온 user 데이터
    const user = {
        name: '픽앤셀',
        email: 'pickNcell@company.com',
        profileImage: `${process.env.PUBLIC_URL}/Logo.png` // 기본 프로필 이미지 예시
    };

    return (
        <div className="common-padding mypage-container">
            <div className="profile-section">
                <img
                src={user.profileImage}
                alt="profile"
                className="profile-image"
                />
                <div className="profile-info">
                    <p className="profile-name">{user.name}</p>
                    <p className="profile-email">{user.email}</p>
                </div>
            </div>

            <div className="button-section">
                <button className='sell-button' onClick={()=>{navigate('/sell')}}>기타 팔러 가기</button>
                <div className='button-wrapper'>
                    <button className="edit-button">회원정보 수정</button>
                    <button
                        className='logout-button'
                        onClick={() => {
                            dispatch(setIsLoggedIn())
                            navigate("/")
                        }}>로그아웃</button>
                </div>
            </div>
        </div>
    )
}

export default MyPage;